<template>
  <footer class="relative bg-gray-300 pt-24 pb-6">
    <div
      class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
      style="height: 80px; transform: translateZ(0px);"
    >
      <svg
        class="absolute bottom-0 overflow-hidden"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        version="1.1"
        viewBox="0 0 2560 100"
        x="0"
        y="0"
      >
        <polygon
          class="text-gray-300 fill-current"
          points="2560 0 2560 100 0 100"
        ></polygon>
      </svg>
    </div>
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap">
        <div class="w-full lg:w-6/12 px-4">
          <h4 class="text-3xl font-semibold">Let's keep in touch!</h4>
          <h5 class="text-lg mt-0 mb-2 text-gray-700">
            Find Lok Lok on any of these platforms, he usually hangout on Instagram.
          </h5>
          <div class="mt-6">
            <a
              class="bg-white inline-flex text-blue-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2 p-3"
              type="button"
              target="_blank" href="https://twitter.com/wonglok831"
            >
              <i class="flex fab fa-twitter"></i></a
            >
            <a
              class="bg-white inline-flex text-blue-600 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2 p-3"
              type="button"
              target="_blank" href="https://facebook.com/thankyoujesuswithloklok"
            >
              <i class="flex fab fa-facebook-square"></i></a
            ><a
              class="bg-white inline-flex text-pink-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2 p-3"
              type="button"
              target="_blank" href="https://instagram.com/effectnode"
            >
              <i class="flex fab fa-instagram"></i></a
            ><a
              class="bg-white inline-flex text-gray-900 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2 p-3"
              type="button"
              target="_blank" href="https://github.com/wonglok"
            >
              <i class="flex fab fa-github"></i>
            </a>
            <a
              class="bg-white inline-flex text-blue-700 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2 p-3"
              type="button"
              target="_blank" href="https://www.linkedin.com/in/wonglok831/"
            >
              <i class="flex fab fa-linkedin"></i>
            </a>
          </div>
        </div>
        <div class="w-full lg:w-6/12 px-4 pt-8 md:pt-0">
          <div class="flex flex-wrap items-top mb-6">
            <div class="w-full lg:w-4/12 px-4 ml-auto">
              <span
                class="block uppercase text-gray-600 text-sm font-semibold mb-2"
                >Lok's Links</span
              >
              <ul class="list-unstyled">
                <!-- <li>
                  <a
                    class="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                    target="_blank" href="http://"
                    >ARTPOP</a
                  >
                </li> -->

                <li>
                  <a
                    class="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                    target="_blank" href="http://o3d-gen3.vercel.app/"
                    >O3D-GEN3</a
                  >
                </li>
                <li>
                  <a
                    class="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                    target="_blank" href="https://effectnode.com"
                    >Effect Node</a
                  >
                </li>
                <li>
                  <a
                    class="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                    target="_blank" href="https://www.iadas.net/membership/bio/lok-wong/7842"
                    >Webbys / IADAS</a
                  >
                </li>
                <li>
                  <a
                    class="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                    target="_blank" href="https://creativecodelab.com"
                    >Creative Code Lab</a
                  >
                </li>
              </ul>
            </div>
            <div class="w-full lg:w-4/12 px-4 mt-12 md:mt-0">
              <span
                class="block uppercase text-gray-600 text-sm font-semibold mb-2"
                >Other Links</span
              >
              <ul class="list-unstyled">
                <li>
                  <a
                    class="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                    target="_blank" href="https://github.com/wonglok/loklok-academy/blob/master/LICENSE.md"
                    >MIT License</a
                  >
                </li>
                <!-- <li>
                  <a
                    class="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                    target="_blank" href="https://creative-tim.com/terms"
                    >Terms &amp; Conditions</a
                  >
                </li> -->
                <!-- <li>
                  <a
                    class="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                    target="_blank" href="https://creative-tim.com/privacy"
                    >Privacy Policy</a
                  >
                </li> -->

                <li>
                  <a
                    class="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                    target="_blank" href="https://www.linkedin.com/in/wonglok831/"
                    >Linked In</a
                  >
                </li>
                <li>
                  <a
                    class="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                    target="_blank" href="https://instagram.com/effectnode"
                    >Contact Lok Lok</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <hr class="my-6 border-gray-400" />

      <div
        class="flex flex-wrap items-center md:justify-between justify-center"
      >
        <div class="w-full md:w-4/12 px-4 mx-auto text-center">
          <div class="text-sm text-gray-600 font-semibold py-1">
            Copyright © 2020
            <a
              target="_blank" href="https://www.wonglok.com"
              class="text-gray-600 hover:text-gray-900"
              >Wong Lok</a
            >.
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {

}
</script>

<style>

</style>